"use client";

import Link from "next/link";

/**
 * Friendly fallback when the booking API (or the page itself) is unavailable.
 */
export function ServiceUnavailable({
  title = "We’re having trouble connecting",
  description = "Book4 is temporarily unavailable. Please try again in a moment. Your account and bookings are safe.",
  onRetry,
  showHomeLink = true,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
  showHomeLink?: boolean;
}) {
  function handleRetry() {
    if (onRetry) {
      onRetry();
      return;
    }
    window.location.reload();
  }

  return (
    <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 shadow-lg text-center">
      <div
        className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-500/15 text-amber-700 dark:text-amber-400"
        aria-hidden
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" x2="12" y1="9" y2="13" />
          <line x1="12" x2="12.01" y1="17" y2="17" />
        </svg>
      </div>
      <h1 className="text-xl font-semibold text-foreground">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{description}</p>
      <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
        <button
          type="button"
          onClick={handleRetry}
          className="w-full sm:w-auto rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm hover:opacity-95 transition-opacity"
        >
          Try again
        </button>
        {showHomeLink && (
          <Link
            href="/"
            className="w-full sm:w-auto rounded-lg border border-border px-5 py-2.5 text-sm font-medium text-foreground hover:bg-muted transition-colors"
          >
            Back to home
          </Link>
        )}
      </div>
    </div>
  );
}
